module.exports = __webpack_public_path__ + "static/img/todomath_main_feature_mode_ja.5917de4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/todomath_main_feature_mode_ja.png
// module id = 81D8
// module chunks = 18